import React, { createContext, useContext, useCallback, useEffect } from 'react'
import { useNavigate, useParams, NavigateOptions } from 'react-router-dom'
import { AppType } from '../utils/appType'
import { applyAppTheme } from '../utils/appTheme'

const AppContext = createContext<AppType>('sushi')

export const AppProvider: React.FC<{
  appType: AppType
  children: React.ReactNode
}> = ({ appType, children }) => {
  useEffect(() => {
    applyAppTheme(appType)
  }, [appType])

  return <AppContext.Provider value={appType}>{children}</AppContext.Provider>
}

export const useAppType = (): AppType => useContext(AppContext)

export const useAppNavigate = () => {
  const navigate = useNavigate()
  const appType = useAppType()

  return useCallback(
    (to: string | number, options?: NavigateOptions) => {
      if (typeof to === 'number') {
        navigate(to)
      } else if (to.startsWith('/')) {
        navigate(`/${appType}${to}`, options)
      } else {
        navigate(to, options)
      }
    },
    [navigate, appType],
  )
}
